module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[103]346.286bed0.woff2";